import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import Filter from 'views/reports/balanceUsers/filter'; // Importing Filter component for user balance filtering
import Table from 'views/reports/balanceUsers/table'; // Importing Table component for displaying user balance data
import Record from 'views/reports/balanceUsers/record'; // Importing Record component for individual user balance records
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the balance users view.
 * @extends JetView
 */
export default class balanceUsersView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Get the current theme configuration from the app
        const theme = this.app.config.theme;
        // Define the configuration for the right panel
        const right = {
            type: 'wide', // Set the type of the panel
            rows: [Record], // Specify the rows to be displayed
        };
        // Define the configuration for the second right panel
        const right2 = {
            height: 1, // Set the height of the panel
            id: 'right2', // Unique identifier for the panel
            width: screen.width - 54, // Set the width based on screen size
            type: 'wide', // Set the type of the panel
            rows: [Record], // Specify the rows to be displayed
        };
        // Define the toolbar configuration
        const toolbar = {
            view: 'toolbar', // Specify the view type as toolbar
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Define the columns within the toolbar
                {
                    view: 'select', // Dropdown selection for page size
                    options: ['10', '20', '50', '100', '1000'], // Options for selection
                    width: 70, // Width of the select element
                    on: {
                        // Event handlers for the select element
                        onChange: function () {
                            // Triggered when selection changes
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size // Convert selected value to number
                            $$('datatable').refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100, 0); // Scroll to a specific position
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    // Template for pager buttons
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetch
                },
                {
                    view: 'richselect', // Rich select for export options
                    name: 'Export', // Name of the select element
                    id: 'Export', // Unique identifier for the rich select
                    width: 120, // Width of the rich select
                    placeholder: _('Exportar'), // Placeholder text for the select
                    options: [
                        // Options for export format
                        { id: '1', value: 'Excel' }, // Option for Excel export
                        { id: '2', value: 'PDF' }, // Option for PDF export
                    ],
                    on: {
                        // Event handlers for the rich select
                        onChange: function (value) {
                            // Triggered when selection changes
                            if (value == 1) {
                                // Check if Excel is selected
                                var table = $$('datatable'); // Get the datatable instance
                                for (
                                    // Loop through columns to prepare for export
                                    var j = 0;
                                    j < table.config.columns.length;
                                    j++
                                ) {
                                    if (table.config.columns[j].exportType) {
                                        // Check for export type
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                // Trigger export event for Excel
                                this.app.callEvent('export:data', [
                                    {
                                        // Set report name based on data availability
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Ajustes de saldo'),
                                        TypeReport: 'Excel', // Specify report type
                                    },
                                ]);
                                // Export the datatable to Excel
                                webix.toExcel(table, {
                                    // Set the filename for the exported file
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Ajustes de saldo'),
                                    ignore: {
                                        // Specify fields to ignore during export
                                        detailTittle: true,
                                        Action: true,
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // Check if PDF is selected
                                    // Trigger export event for PDF
                                    this.app.callEvent('export:data', [
                                        {
                                            // Set report name based on data availability
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Ajustes de saldo'),
                                            TypeReport: 'PDF', // Specify report type
                                        },
                                    ]);
                                    // Export the datatable to PDF
                                    webix.toPDF($$('datatable'), {
                                        // Set the filename for the exported file
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Ajustes de saldo'),
                                        autowidth: true, // Enable automatic width adjustment
                                        ignore: {
                                            // Specify fields to ignore during export
                                            detailTittle: true,
                                            Action: true,
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset the export selection
                        }.bind(this), // Bind the context to the function
                    },
                },
            ],
        };
        const toolbar2 = {
            /**
             * Toolbar configuration object.
             * @type {Object}
             */
            view: 'toolbar',
            id: 'toolbar2',
            css: 'highlighted_header header6',
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                {
                    /**
                     * Dropdown select for page size options.
                     * @type {Object}
                     */
                    view: 'select',
                    options: ['10', '20', '50', '100', '1000'], // Options for page size
                    width: 70, // Width of the select box
                    on: {
                        /**
                         * Event handler for changing the page size.
                         * Updates the pager size and refreshes the datatable.
                         */
                        onChange: function () {
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Set pager size based on selected value
                            $$('datatable').refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100, 0); // Scroll to the right position
                        },
                    },
                },
                {
                    /**
                     * Pager component for navigation through pages.
                     * @type {Object}
                     */
                    view: 'pager',
                    id: 'pagerB',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default page size from configuration
                },
                {
                    /**
                     * Rich select for export options (Excel, PDF).
                     * @type {Object}
                     */
                    view: 'richselect',
                    name: 'Export',
                    id: 'Export',
                    width: 120, // Width of the rich select
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Option for Excel export
                        { id: '2', value: 'PDF' }, // Option for PDF export
                    ],
                    on: {
                        /**
                         * Event handler for export option change.
                         * Exports the datatable to the selected format.
                         * @param {string} value - The selected export option.
                         */
                        onChange: function (value) {
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Get the datatable instance
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Ajustes de saldo'), // Report name
                                        TypeReport: 'Excel', // Report type
                                    },
                                ]);
                                webix.toExcel(table, {
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Ajustes de saldo'), // Filename for the exported file
                                    ignore: {
                                        detailTittle: true, // Ignore detail title in export
                                        Action: true, // Ignore Action column in export
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Ajustes de saldo'), // Report name
                                            TypeReport: 'PDF', // Report type
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Ajustes de saldo'), // Filename for the exported file
                                        autowidth: true, // Enable auto width for PDF
                                        ignore: {
                                            detailTittle: true, // Ignore detail title in export
                                            Action: true, // Ignore Action column in export
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset the export selection
                        }.bind(this), // Bind the context to the event handler
                    },
                },
            ],
        };
        const left = {
            /**
             * Configuration object for the left panel.
             * Contains an array of rows with various UI components.
             */
            rows: [
                {
                    /**
                     * Toolbar configuration.
                     * Displays a label and buttons for actions.
                     */
                    view: 'toolbar',
                    css: theme, // CSS class for styling the toolbar
                    elements: [
                        {
                            /**
                             * Label element displaying the title of the report.
                             */
                            view: 'label',
                            label: _('Reporte de Saldos Online'), // Translated label text
                        },
                        {
                            /**
                             * Wide button for search functionality.
                             */
                            type: 'wide',
                            css: 'close-bottom', // CSS class for styling
                            id: 'button-search', // Unique identifier for the button
                            cols: [
                                {
                                    /**
                                     * Icon button for triggering the search popup.
                                     */
                                    view: 'icon',
                                    icon: 'wxi-search', // Icon representing search action
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => {
                                        $$('filterPopup').show(); // Show the filter popup on click
                                    },
                                },
                            ],
                        },
                        {
                            /**
                             * Wide button for closing the current view and navigating to the dashboard.
                             */
                            type: 'wide',
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                {
                                    /**
                                     * Icon button for closing the current view.
                                     */
                                    view: 'icon',
                                    icon: 'wxi-close', // Icon representing close action
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                Filter, // Reference to the Filter component
                Table, // Reference to the Table component
                toolbar, // Reference to the first toolbar component
                toolbar2, // Reference to the second toolbar component
            ],
        };
        /**
         * Configuration object for the advanced details accordion.
         * @type {Object}
         * @property {string} view - The type of view, set to 'accordion'.
         * @property {boolean} multi - Allows multiple items to be opened at once.
         * @property {boolean} collapsed - Indicates if the accordion is initially collapsed.
         * @property {Array} cols - Array of column configurations.
         * @property {Object} cols[].id - Unique identifier for the column.
         * @property {string} cols[].header - Header text for the column.
         * @property {Object} cols[].body - Content to be displayed in the column.
         */
        const avanc = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [{ id: 'dColl', header: _('Detalles Avanzados'), body: right }],
        };

        /**
         * Configuration object for the advanced details accordion response.
         * @type {Object}
         * @property {string} view - The type of view, set to 'accordion'.
         * @property {boolean} multi - Allows multiple items to be opened at once.
         * @property {boolean} collapsed - Indicates if the accordion is initially collapsed.
         * @property {string} id - Unique identifier for the accordion.
         * @property {Array} rows - Array of row configurations within the accordion.
         * @property {Object} rows[].id - Unique identifier for the row.
         * @property {string} rows[].header - Header text for the row.
         * @property {Object} rows[].body - Content to be displayed in the row.
         * @property {number} rows[].minWidth - Minimum width for the row.
         * @property {Object} rows[].on - Event handlers for the row.
         * @property {Function} rows[].on.onItemClick - Function to execute on item click.
         */
        const avancResp = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            id: 'carousel1',
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'),
                    body: right,
                    minWidth: 250,
                    on: {
                        /**
                         * Event handler for item click event.
                         * Calculates the height of the scrolling container and applies a CSS transform
                         * to adjust the position based on the accordion's collapsed state.
                         */
                        onItemClick: function () {
                            var height;
                            $$(function () {
                                // Calculate the height of the scrolling container
                                height =
                                    $$('.scrolling > .webix_scroll_cont').height() -
                                    $$('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                // Apply CSS transform based on the collapsed state
                                if (!$$('dColl').config.collapsed) {
                                    $$('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                } else {
                                    height =
                                        $$('.scrolling > .webix_scroll_cont').height() -
                                        $$('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $$('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };
        // Set the Webix UI to full screen mode
        webix.ui.fullScreen();

        // Return an object representing a form layout
        return {
            // Unique identifier for the form
            id: 'as5',

            // Type of the form layout
            type: 'clean',

            // View type for the form
            view: 'form',

            // Enable vertical scrolling
            scroll: 'y',

            // Define the rows within the form
            rows: [
                {
                    // Responsive property for layout adjustment
                    responsive: 'as5',

                    // Type of layout for the row
                    type: 'wide',

                    // Define columns within the row
                    cols: [
                        left, // Reference to the left column component

                        // Conditional rendering of the right column based on screen size
                        screen.width < 500 || screen.height < 500
                            ? right2 // Use right2 if screen dimensions are less than 500
                            : avanc, // Otherwise, use avanc
                    ],
                },
            ],
        }; // Placeholder for the view's configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        webix.ready(function () {
            // Check if the screen width is less than 500 pixels
            if (screen.width < 500) {
                // Get child views of the 'toolbar' component
                var childs = $$('toolbar').getChildViews();
                // Remove the third child view from the 'toolbar'
                $$('toolbar').removeView(childs[2]);
                // Define 'group' property for 'pagerA' component
                $$('pagerA').define('group', 1);
                // Get child views of the 'toolbar2' component
                var childs2 = $$('toolbar2').getChildViews();
                // Remove the third child view from the 'toolbar2'
                $$('toolbar2').removeView(childs2[2]);
                // Define 'group' property for 'pagerB' component
                $$('pagerB').define('group', 1);
            }
            // Check if the screen width and height are both greater than 500 pixels
            if (screen.width > 500 && screen.height > 500) {
                // Hide the 'button-search' component
                $$('button-search').hide();
            }
            // jQuery function to calculate the scroll bottom position
            $.fn.scrollBottom = function () {
                // Return the distance from the bottom of the document to the bottom of the viewport
                return $$(document).height() - this.scrollTop() - this.height();
            };
        }); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
